var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "streetViewContainer" } }, [
    _vm.ladybugSrc1 && !_vm.c1SuccessfulLoad
      ? _c(
          "div",
          { staticClass: "loading-wrapper" },
          [
            _c("fa", {
              staticClass: "loading-icon",
              attrs: { icon: ["fas", "spinner"], spin: "" },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "loading-text" }, [
              _vm._v("Loading image..."),
            ]),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.ladybugSrc1 && _vm.c1SuccessfulLoad,
            expression: "ladybugSrc1 && c1SuccessfulLoad",
          },
        ],
        staticClass: "wrapper",
      },
      [
        _c(
          "div",
          {
            staticClass: "box",
            attrs: { id: "streetViewBottom" },
            on: {
              click: function ($event) {
                return _vm.openImgInNewTab("ladybugStreetViewC1")
              },
            },
          },
          [
            _c("h5", { staticClass: "image-text top-left-text unselectable" }, [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.ladybugImageryAttributeData.datetime) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "h5",
              { staticClass: "image-text top-right-text unselectable" },
              [_vm._v("C1")]
            ),
            _vm._v(" "),
            _c(
              "h5",
              { staticClass: "image-text bottom-right-text unselectable" },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.ladybugImageryAttributeData.processing_index) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c("img", {
              staticClass: "clickable",
              attrs: {
                id: "ladybugStreetViewC1",
                src: _vm.ladybugSrc1,
                alt: "C1",
                height: _vm.bImg1Height,
                width: _vm.bImg1Width,
              },
              on: {
                load: function ($event) {
                  return _vm.imageFound()
                },
              },
            }),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "imageryRotateDiv",
            attrs: { id: "imageryRotateDiv1" },
          },
          [
            _c(
              "button",
              {
                staticClass: "imageryRotateButton",
                attrs: {
                  id: "imageryRotateButton1",
                  size: "sm",
                  title: "image rotate",
                },
                on: {
                  click: function ($event) {
                    return _vm.imageRotate("ladybugStreetViewC1")
                  },
                },
              },
              [
                _c(
                  "span",
                  [
                    _c("fa", {
                      staticStyle: { color: "white" },
                      attrs: { icon: ["fas", "sync-alt"] },
                    }),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }